//	------------------------	------------------------	------------------------
//	Imports
//	------------------------	------------------------	------------------------

import moment from 'moment-timezone'


import firebase_auth from 'xAppLib/providers/firebase_auth.js';
import API_service from 'xAppLib/providers/API_service'

import obj_diff from 'xAppLib/helpers/obj_diff'

import org_model from 'models/org_model'
import MedicareCard from 'xAppLib/UIelems/MedicareCard'
import gtm from 'xAppLib/providers/gtm';

import validations from 'xAppLib/libs/validations'
import { consults_for_followup } from "../views/med/utils";

//	------------------------	------------------------	------------------------
//  Globals
//	------------------------	------------------------	------------------------

const DEBUG = true

//	------------------------	------------------------	------------------------
//  Globals
//	------------------------	------------------------	------------------------

const _FRDB_LOC = 'user_profs';

//	------------------------	------------------------	------------------------
//  Lists
//	------------------------	------------------------	------------------------

const _ROLE_LIST = {
						10: { c: 'root', 	n: 'Root' 		, p: ['root']	},
						9:  { c: 'admin', 	n: 'Admin' 		, p: ['root', 'admin']	},
						8:  { c: 'supp', 	n: 'Support'	, p: ['root', 'admin']	},
						7:  { c: 'mark', 	n: 'Analyst'	, p: ['root', 'admin']	},
						6:  { c: 'pri', 	n: 'Principal'	, p: ['root', 'admin']	},
						5:  { c: 'mang', 	n: 'Manager'	, p: ['root', 'admin', 'cust_supp', 'mang']	},
						4:  { c: 'teach', 	n: 'Teacher'	, p: ['root', 'admin', 'cust_supp', 'mang']	},
						3:  { c: 'team', 	n: 'TeamLeader'	, p: ['root', 'admin', 'cust_supp', 'mang']	},
						2:  { c: 'usr', 	n: 'User'		, p: ['root', 'admin']	},
						// 1:  { c: 'user', 	n: 'User'		, p: ['root', 'admin']	},
				}

const _SEX_LIST_BASE = [
	{text:"Male", key: "M", value:"M" },
	{text:"Female", key: "F", value:"F" },
]

const _SEX_LIST_FULL = [
	..._SEX_LIST_BASE,
	{text:"Unknown", key: "N", value:"N" },
]

// Year of Birth list (current year down to 1920)
const _CURRENT_YEAR = new Date().getFullYear()
const _YOB_LIST = Array.from({ length: _CURRENT_YEAR - 1920 + 1 }, (_, i) => {
	const year = _CURRENT_YEAR - i
	return { text: year.toString(), key: year.toString(), value: year.toString() }
})

// Country list - common countries first, then alphabetical
const _COUNTRY_LIST = [
	{ text: "Australia", key: "AU", value: "AU" },
	{ text: "United States", key: "US", value: "US" },
	{ text: "United Kingdom", key: "GB", value: "GB" },
	{ text: "New Zealand", key: "NZ", value: "NZ" },
	{ text: "Canada", key: "CA", value: "CA" },
	{ text: "---", key: "divider", value: "", disabled: true },
	{ text: "Afghanistan", key: "AF", value: "AF" },
	{ text: "Argentina", key: "AR", value: "AR" },
	{ text: "Austria", key: "AT", value: "AT" },
	{ text: "Belgium", key: "BE", value: "BE" },
	{ text: "Brazil", key: "BR", value: "BR" },
	{ text: "Chile", key: "CL", value: "CL" },
	{ text: "China", key: "CN", value: "CN" },
	{ text: "Colombia", key: "CO", value: "CO" },
	{ text: "Denmark", key: "DK", value: "DK" },
	{ text: "Egypt", key: "EG", value: "EG" },
	{ text: "Finland", key: "FI", value: "FI" },
	{ text: "France", key: "FR", value: "FR" },
	{ text: "Germany", key: "DE", value: "DE" },
	{ text: "Greece", key: "GR", value: "GR" },
	{ text: "Hong Kong", key: "HK", value: "HK" },
	{ text: "India", key: "IN", value: "IN" },
	{ text: "Indonesia", key: "ID", value: "ID" },
	{ text: "Ireland", key: "IE", value: "IE" },
	{ text: "Israel", key: "IL", value: "IL" },
	{ text: "Italy", key: "IT", value: "IT" },
	{ text: "Japan", key: "JP", value: "JP" },
	{ text: "Malaysia", key: "MY", value: "MY" },
	{ text: "Mexico", key: "MX", value: "MX" },
	{ text: "Netherlands", key: "NL", value: "NL" },
	{ text: "Norway", key: "NO", value: "NO" },
	{ text: "Pakistan", key: "PK", value: "PK" },
	{ text: "Philippines", key: "PH", value: "PH" },
	{ text: "Poland", key: "PL", value: "PL" },
	{ text: "Portugal", key: "PT", value: "PT" },
	{ text: "Russia", key: "RU", value: "RU" },
	{ text: "Saudi Arabia", key: "SA", value: "SA" },
	{ text: "Singapore", key: "SG", value: "SG" },
	{ text: "South Africa", key: "ZA", value: "ZA" },
	{ text: "South Korea", key: "KR", value: "KR" },
	{ text: "Spain", key: "ES", value: "ES" },
	{ text: "Sweden", key: "SE", value: "SE" },
	{ text: "Switzerland", key: "CH", value: "CH" },
	{ text: "Taiwan", key: "TW", value: "TW" },
	{ text: "Thailand", key: "TH", value: "TH" },
	{ text: "Turkey", key: "TR", value: "TR" },
	{ text: "United Arab Emirates", key: "AE", value: "AE" },
	{ text: "Vietnam", key: "VN", value: "VN" },
]


//	------------------------	------------------------	------------------------
//  Field templates
//	------------------------	------------------------	------------------------

const field = {
	unum: {
		name: 'unum',
		label: 'User Number',
		read_only: true,
	},
	uid: {
		name: 'uid',
		label: 'User ID',
		read_only: true,
		type: 'uid',
	},
	username: {
		name: 'username',
		label: 'Username',
		pattern: /^[A-Za-z][A-Za-z0-9_]{0,19}$/,
		validation_message: "Username must be up to 20 characters, start with a letter, and contain only letters, numbers, and underscores",
	},
	email: {
		name: 'email',
		label: 'Email',
		read_only: true,
		disabled: true,
		//icon: 'mail',
	},
	email_required: {
		name: 'email',
		label: 'Email',
		//icon: 'mail',
	},
	first_name: {
		name: 'first_name',
		label: 'First name',
		//icon: 'user',
		valid_not_required: true,
		pattern: /^[A-Za-z][A-Za-z0-9\-' ]+$/,
		validation_message:"Must contain only characters A-Z, a-z, 0-9, -, ' and spaces",
	},
	first_name_min: {
		name: 'first_name',
		label: 'First name',
		//icon: 'user',
	},
	last_name: {
		name: 'last_name',
		label: 'Last name',
		//icon: 'user',
		valid_not_required: true,
		pattern: /^[A-Za-z][A-Za-z0-9\-' ]+$/,
		validation_message:"Must contain only characters A-Z, a-z, 0-9, -, ' and spaces",
	},
	last_name_min: {
		name: 'last_name',
		label: 'Last name',
		//icon: 'user',
	},
	dob: {
		name: 'dob',
		label: 'Date of Birth',
		type: 'dob_date',
		//icon: 'calendar',
		validate_function: value => validations.validate_date(value),
	},
	sex: {
		name: 'sex',
		label: 'Sex',
		type: 'select',
		options: _SEX_LIST_BASE,
		note:'We realise this is a sensitive question for some patients. However, in order for our doctors to ensure your safety and prescribe the correct medications for you it is important that we obtain this information.'
	},
	sex_adv: {
		name: 'sex',
		label: 'Sex',
		type: 'select',
		placeholder: '⚤ Sex',
		options: _SEX_LIST_FULL,
	},
	mobile: {
		name: 'mobile',
		label: 'Mobile phone number',
		type: 'masked',
		mask: [ /\d/, /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, ' ',/\d/, /\d/, /\d/ ],
		placeholder: "04XX XXX XXX",
		pattern: /^04\s?[0-9]{2}\s?[0-9]{3}\s?[0-9]{3}$/,
		//icon: 'mobile',
		//valid_not_required: true,
	},
	full_address: {
		name: 'full_address',
		label: 'Primary Residential Address',
		type: 'address',
		// icon: 'address card',
		mode: 'components',
		valid_not_required: false,
		validate_function: (value) => /^\d{4}$/.test(value.postcode),
		validation_message: (value) => {
			if (!/^\d{4}$/.test(value.postcode))
				return "Must be a valid postcode";
			return false;
		},	
	},
	suburb: { // Depreciated
		name: 'suburb',
		label: 'Suburb',
		read_only: true,
	},
	state: { // Depreciated
		name: 'state',
		label: 'State',
		read_only: true,
	},
	postcode: { // Depreciated
		name: 'postcode',
		label: 'Postcode',
		read_only: true,
	},
	geo: {
		name: 'geo',
		label: 'Geo',
		read_only: true,
		type: 'json',
		view_path: 'formatted_address',
	},
	xtra: {
		name: 'xtra',
		label: 'Extra Fields',
		type: 'json',
		// default: {
		// 	AHPRA: ""
		// },
		valid_not_required: true,
	},
	extras: {
		name: 'extras',
		label: 'Extra Conf',
		type: 'json',
		valid_not_required: true,
	},
	active: {
		name: 'active',
		label: 'Active',
		type: 'bool',
		valid_not_required: true,
	},
	cre_tm: {
		name: 'cre_tm',
		label: 'Created',
		read_only: true,
	},
	acc_tm: {
		name: 'acc_tm',
		label: 'Last Access',
		read_only: true,
	},
	upd_tm: {
		name: 'upd_tm',
		label: 'Updated',
		read_only: true,
	},
	auth: {
		name: 'auth',
		label: 'Authentication Meta',
		read_only: true,
		type: 'json',
		view_path: 'metadata',
	},
	password: {
		name: 'password',
		label: 'Password',
		type: 'password',
		with_validator:true,
		// icon: 'lock',
		// pattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[A-Za-z\d@$!%*?&]{8,}$/,
		// validation_message: "Password must be at least 8 characters and contain at least one uppercase letter, one lowercase letter, and one number",
		pattern: /^.{8,}$/,
		validation_message: "Password must be at least 8 characters",
	},
	verify_password: {
		name: 'verify_password',
		label: 'Confirm new password',
		type: 'password',
		// icon: 'lock',
	},
	nu_org: {
		name: "nu_org",
		label:'Organisation',
		type: "org",
		param_name: "oid",
		valid_not_required: true,
	},
	claims: {
		name: 'claims',
		label:'Role',
		type: 'role',
		valid_not_required: true,
	},
	send_pass: {
		name: "send_pass",
		label:'Send Password in Email',
		type: "checkbox",
		options: [ {c:'yes', n:'include password'} ],
		valid_not_required: true,
	},
	no_email: {
		name: "no_email",
		label:'Do Not Email User',
		type: "checkbox",
		options: [ {c:'no', n:'No Email'} ],
		valid_not_required: true,
	},
	note: {
		name: "note",
		label: 'Additional note to email',
		type: "textarea",
		value: "To use your account, login at /",
		valid_not_required: true,
	},
	mfa: {
		name: 'mfa',
		label: 'Multi-factor Authentication',
		type: 'bool',
		valid_not_required: true,
	},
	consent: {
		name: 'consent',
		label: 'Privacy',
		type: 'privacy',
		// auto:true,
		
	},
	em_con_name: {
		name: 'em_con_name',
		label: 'Emergency Contact Name',
		//icon: 'user',
		pattern: /^[A-Za-z][A-Za-z0-9\-' ]+$/,
		validation_message:"Must contain only characters A-Z, a-z, 0-9, -, ' and spaces",
		valid_not_required: true,
	},
	em_con_mobile: {
		name: 'em_con_mobile',
		label: 'Emergency Contact Mobile',
		type: 'masked',
		mask: [ /\d/, /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, ' ',/\d/, /\d/, /\d/ ],
		placeholder: "04XX XXX XXX",
		pattern: /^04\s?[0-9]{2}\s?[0-9]{3}\s?[0-9]{3}$/,
		//icon: 'mobile',
		valid_not_required: true,
	},
	em_con_rel: {
		name: 'em_con_rel',
		label: 'Relationship of emergency contact to patient',
		//icon: 'user',
		pattern: /^[A-Za-z][A-Za-z0-9\-' ]+$/,
		validation_message:"Must contain only characters A-Z, a-z, 0-9, -, ' and spaces",
		valid_not_required: true,
	},
	yob: {
		name: 'yob',
		label: 'Year of Birth',
		type: 'select',
		options: _YOB_LIST,
		placeholder: 'Select year',
		valid_not_required: true,
	},
	city: {
		name: 'city',
		label: 'City',
		placeholder: 'City',
		valid_not_required: true,
	},
	loc_state: {
		name: 'loc_state',
		label: 'State / Province',
		placeholder: 'State or Province',
		valid_not_required: true,
	},
	country: {
		name: 'country',
		label: 'Country',
		type: 'select',
		options: _COUNTRY_LIST,
		placeholder: 'Select country',
		valid_not_required: true,
	},
	loc_postcode: {
		name: 'loc_postcode',
		label: 'Postcode / ZIP',
		placeholder: 'Postcode or ZIP code',
		valid_not_required: true,
	},
}


//	------------------------	------------------------	------------------------
//  Field collections
//	------------------------	------------------------	------------------------

const _PROF_FIELDS_ADMIN = [
		field.unum,
		field.uid,
		field.email,
		{...field.username, valid_not_required: true,},
		field.first_name_min,
		field.last_name_min,
		{...field.dob,valid_not_required: true},
		// {...field.sex_adv,valid_not_required: true},
		{...field.mobile,valid_not_required: true},
		// field.full_address,
		field.suburb,
		field.state,
		field.postcode,
		field.geo,
		field.xtra,
		app.user?.claims?.root && field.extras,
		field.active,
		field.cre_tm,
		field.acc_tm,
		field.upd_tm,
		field.auth,
		field.em_con_name,
		field.em_con_mobile,
		field.em_con_rel,
	].filter(Boolean)

const _PROF_FIELDS_MANG = [
	field.email,
	field.first_name_min,
	field.last_name_min,
	{...field.dob,valid_not_required: true},
	// field.sex,
	field.mobile,
	// field.full_address,
	field.suburb,
	field.state,
	field.postcode,
	field.geo,
	field.xtra,
	field.active,
	field.em_con_name,
	field.em_con_mobile,
	field.em_con_rel,
]

const _PROF_FIELDS_ADM_SGUP = [
	field.email_required,
	field.first_name_min,
	field.last_name_min,
	{...field.dob,valid_not_required: true},
	// {...field.sex_adv,valid_not_required: true},
	{...field.mobile,valid_not_required: true},
	// field.full_address,
	field.password,
	field.nu_org,
	field.claims,
	field.send_pass,
	field.no_email,
	field.note,
	field.em_con_name,
	field.em_con_mobile,
	field.em_con_rel
]

const _PROF_FIELDS_DOC_SGUP = [
	{...field.email, read_only: false, disabled: false},
	field.first_name_min,
	field.last_name_min,
	field.dob,
	// field.sex,
	field.mobile,
	// field.full_address,
	field.password,
	field.send_pass,
	field.no_email,
	field.note,
	field.consent,
	field.em_con_name,
	field.em_con_mobile,
	field.em_con_rel
]

const _PROF_FIELDS_PTS_BASE = [

	field.first_name,
	field.last_name,
	// field.full_address,
	field.em_con_name,
	field.em_con_mobile,
	field.em_con_rel

]


/// --------

const _PROF_FIELDS_SGUP = [
	{...field.email, read_only: false, disabled: false},
	field.username,
	..._PROF_FIELDS_PTS_BASE,
	{...field.dob, valid_not_required: true,},
	{...field.sex, valid_not_required: true,},
	{...field.mobile, valid_not_required: true,},
	field.yob,
	field.city,
	field.loc_state,
	field.country,
	field.loc_postcode,

	field.password,
	field.verify_password,
	field.consent,
	]

const _PROF_FIELDS_PTS_SGUP = [
	field.email,
	field.first_name,
	field.last_name,
	field.dob,
	field.sex,
	field.mobile,
	// field.full_address,
	field.password,
	field.verify_password,
	field.consent,
	field.em_con_name,
	field.em_con_mobile,
	field.em_con_rel
]


const _PROF_FIELDS_MY = [
	{
		name: 'desc',
		label: 'Profile Name / Description',
		type: "hidden",
		value: null
	},
	{
		name: 'hbbs',
		type: "hidden",
	},
	field.cons_has_allergies,
	field.cons_allergy,
	field.email,
	{...field.username, valid_not_required: true,},
	..._PROF_FIELDS_PTS_BASE,
	{...field.dob, valid_not_required: true,},
	{...field.sex, valid_not_required: true,},
	{...field.mobile, valid_not_required: true,},
	field.yob,
	field.city,
	field.loc_state,
	field.country,
	field.loc_postcode,

]
const _PROF_FIELDS_MY_CHILD = [
	{
		name: 'desc',
		label: 'Profile Name / Description',
	},
	{
		name: 'hbbs',
		type: "hidden",
	},
	field.cons_has_allergies,
	field.cons_allergy,
	field.email,
	..._PROF_FIELDS_PTS_BASE,
	{...field.dob, valid_not_required: true,},
	{...field.sex, valid_not_required: true,},
	{...field.mobile, valid_not_required: true,},
	field.yob,
	field.city,
	field.loc_state,
	field.country,
	field.loc_postcode,
]

const _PROF_MEDICAL_HISTORY = [
	field.cons_has_allergies,
	field.cons_allergy,
	{
		label: 'Brief medical history.',
		placeholder: 'History',
		name: "cons_medhist",
		type: "textarea",
		rows: 2,
		valid_not_required: true,
	},
	{
		label: 'What medications are you currently taking?',
		placeholder: 'Please list any medication you are currently taking',
		name: "cons_meds",
		type: "text",
		valid_not_required: true,
		rows: 2,
	}
]

export default class user_model extends firebase_auth {

	// ---- --------------------------------------------  --------------------------------------------  
	// ---- --------------------------------------------  --------------------------------------------  

	static get ROLE_LIST() { return _ROLE_LIST; }
	static get PROF_FIELDS_ADMIN() { return _PROF_FIELDS_ADMIN; }
	static get PROF_FIELDS_MANG() { return _PROF_FIELDS_MANG; }
	static get PROF_FIELDS_ADM_SGUP() { return _PROF_FIELDS_ADM_SGUP; }
	static get PROF_FIELDS_DOC_SGUP() { return _PROF_FIELDS_DOC_SGUP; }
	static get PROF_FIELDS_SGUP() { return _PROF_FIELDS_SGUP; }
	static get PROF_FIELDS_PTS_SGUP() { return _PROF_FIELDS_PTS_SGUP; }
	static get PROF_FIELDS_MY() { return _PROF_FIELDS_MY; }
	static get PROF_FIELDS_MY_CHILD() { return _PROF_FIELDS_MY_CHILD; }
	static get PROF_MEDICAL_HISTORY() { return _PROF_MEDICAL_HISTORY; }

	// ----	--------------------------------------------	--------------------------------------------	
	// ----	--------------------------------------------	--------------------------------------------	

	static check_access (a, p) {

		let r = false;
		let cat_nm;

		switch (a) {
			case 'pg_med':
				r = app.user?.claims?.admin
						|| p=='iLeg_cat' && app.user?.org?.type=='leg' && p==org_model.org_conf_itm(app.user.org, 'meds') && app.user?.claims?.nurse && app.user.claims.oid 
						|| p!='pharm' && app.dvc?.org?.type=='cosm' && p==org_model.org_conf_itm(app.user.org, 'meds') && app.user?.claims?.nurse && app.user.claims.oid 
						|| p!='pharm' && p==org_model.org_conf_itm(app.user.org, 'meds') && app.acl.is_doc_presc
						|| p=='pharm' && app.dvc?.org?.type=='pharm'
						// || app.user?.claims?.pts
						|| (p=='pharm' || p=='patho') && app.user.user_in 
								&& org_model.org_conf_itm(app.runtime.org, 'is_mc')
				// r = app.dvc.data && app.dvc.data.pharm_id 
				// 		|| app.dvc.data && app.dvc.data.org_id && app.user && app.user.claims && app.user.claims.nurse
				// 		|| app.user && app.user.claims && app.user.claims.admin
				DEBUG && console.log('check_access ', a, p, app.user?.org?.type, org_model.org_conf_itm(app.user.org, 'meds'), r);
				break;


			case 'pg_cat':
				cat_nm = p?.replace(/^_/, '') || 'pharm'
				// console.log('check_access ', a, r, p, org_model.org_conf_itm(app.user.org, 'meds'));
				r = app.user?.claims?.admin

						|| !p && app.dvc?.org?.type=='pharm' 
						|| cat_nm=='pharm' 
						|| cat_nm=='patho' 

						|| cat_nm==org_model.org_conf_itm(app.user.org, 'meds') && app.dvc?.org?.type=='cosm' || app.user?.org?.type=='leg' && (app.user?.claims?.nurse||app.user?.claims?.mang)
						|| cat_nm==org_model.org_conf_itm(app.user.org, 'meds') && app.acl.is_doc_presc

						// || app.user?.claims?.mang
						// || app.user?.claims?.nurse
						// || !p && app.user?.claims?.doc
								// && app.dvc.org?.type!='cosm' 
								// && app.user && app.user.prof /*&& !app.user.prof.claims*/
								// && org_model.org_conf_itm(app.user.org, 'is_mc')
				// r = !p && app.dvc.data && app.dvc.data.pharm_id 
				// 		|| p && p=='_cosm' && app.dvc.data && app.dvc.data.org_id && app.user && app.user.claims && (app.user.claims.nurse||app.user.claims.mang||app.user.claims.doc)
				// 		|| app.user && app.user.claims && app.user.claims.admin
				break;

			case true:
			case 'user':
				r = app.user.user_in
				if (p && app.user.user_det && app.user.user_det.providerData[0].providerId != p ) {
					r = false
				}
				break;


			case 'cust_supp':
				r = app.user?.claims?.admin 
					|| app.user?.claims?.supp 
				break;


			case 'view_orgs':
				r = app.user?.claims?.admin 
					|| app.user?.claims?.supp 
					|| app.user?.claims?.mark 
					|| app.user?.claims?.doc
					|| app.user?.claims?.mang
				break;


			case 'view_all_orgs':
				r = app.user?.claims?.admin 
					|| app.user?.claims?.supp 
					|| app.user?.claims?.mark 
					|| app.user?.claims?.doc
				break;

			case 'view_my_orgs':
				r = app.user?.claims?.mang
				break;


			case 'phts_add':
			case 'phts_view':
				r = app.user?.claims?.admin 
					|| app.user?.claims?.supp 
					|| app.user?.claims?.mark 
					|| app.user?.claims?.mang 
					|| app.user?.claims?.doc 
					|| app.user?.claims?.nurse 
					// || app.user?.claims?.pharm;
				break;

			case 'attch_view':
				r = app.user?.claims?.admin 
					|| app.user?.claims?.supp 
					|| app.user?.claims?.doc && org_model.org_conf_itm(app.user.org, 'is_GP');
				break;

			case 'pts_srch':
			case 'pts_view':
				r = app.user?.claims?.admin 
					|| app.user?.claims?.supp 
					|| app.user?.claims?.mark 
					|| app.user?.claims?.mang 
					|| app.user?.claims?.doc 
					|| app.user?.claims?.nurse 
					|| app.user?.claims?.pharm;
				break;

			case 'root':
				r = app.user?.claims?.root
				break;

			case 'admin':
			case 'admin_med':
				r = app.user?.claims?.admin
				break;
			
			case 'user_admin':
				r = app.user?.claims?.admin || app.user?.claims?.supp
				break;

			case 'admin_devices':
				r = app.user?.claims?.admin || app.user?.claims?.supp && app.user?.claims?.mang
				break;

			case 'GP':
				r = app.user?.claims?.admin || app.user?.claims?.doc && org_model.org_conf_itm(app.user.org, 'is_GP')
				break;

			case 'doccons_view':
				r = app.user?.claims?.admin || app.user?.claims?.doc && org_model.org_conf_itm(app.user.org, 'is_GP') || app.user
				break;


			case 'scripts_stats':
				r = app.user?.claims?.admin || app.user?.claims?.mark || app.user?.claims?.mang || app.user?.claims?.doc || app.user?.claims?.nurse || app.user?.claims?.pharm
				break;

			case 'docs_stats':
				r = app.user?.claims?.admin || app.user?.claims?.doc || app.user?.prof?.xtra?.show_docs_stats
				break;

			case 'use_stats':
				r = app.user?.claims?.admin || app.user?.claims?.mark || app.user?.prof?.xtra?.show_docs_scr_stats
				break;


			case 'show_support':
				r = app.dvc.org || app.user && app.user.claims && (app.user.claims.admin || app.user.claims.mark || app.user.claims.mang || app.user.claims.nurse || app.user.claims.pharm)
				break;

			case 'show_contact':
				r = !app.user || !(app.user.claims?.admin || app.user.claims?.mark)
				break;


			case 'scripts_list':
				r = app.user && app.user.claims && (app.user.claims.admin || app.user.claims.supp || app.user.claims.mang || app.user.claims.doc || app.user.claims.nurse || app.user.claims.pharm)
				break;


			case 'view_scripts':
				r = app.user && app.user.claims && (app.user.claims.admin || app.user.claims.supp || app.user.claims.mang || app.user.claims.doc || app.user.claims.nurse || app.user.claims.pharm)
				break;
			
			case 'prescs':
				r = app.user?.claims?.admin || app.user?.claims?.doc || app.user?.claims?.supp
				break;

			case 'adm_treatment_plan':
				r = app.acl.is_admin || app.acl.is_supp || app.acl.is_doc_gp;
				break;

			case 'buy_prods':
				r = app.user?.claims?.admin 
					|| app.user?.claims?.mang && app.user.org?.conf?.prods_sale?.includes('med_cosm') 
					|| app.user?.prof?.xtra?.prods_sale?.includes('med_cosm')
					|| ['bpm', 'pay_us'].includes(p) && app.user.user_in
				break;

			case 'view_all_prod_trans':
				r = app.user?.claims?.root || app.user?.claims?.admin || app.user?.claims?.supp || app.user?.claims?.mark && app.user?.prof?.xtra?.show_prod_trans;
				break;

			case 'raw_data':
				r = app.user && app.user.claims && app.user.claims.root
				break;

			case 'nurse':
				r = app.user.user_in && app.user.claims&&app.user.claims.nurse&&app.user.claims.oid 
				break;
			
			case 'mang':
				r = app.user.user_in && app.user.claims&&app.user.claims.mang&&app.user.claims.oid 
				break;

			case 'mang_cosm':
				r = app.user.user_in && app.user.claims&&app.user.claims.mang&&app.user.claims.oid && (app.user.org?.type=='cosm' || app.user.org?.type=='leg')
				break;

			case 'mang_pharm':
				r = app.user.user_in && app.user.claims&&app.user.claims.mang&&app.user.claims.oid && app.user.org?.type=='pharm'
				break;

			case 'pharm' :
				r = app.user.user_in && app.user.claims&&app.user.claims.pharm&&app.user.claims.oid
				break;
			
			case 'doc' :
				r = app.user.claims.admin || app.user.claims.supp || app.user.claims?.doc&&app.user.claims.doc_id 
				break;

			case 'pts':
				r = app.user.user_in && this.deny_all(['admin','nurse','mang','doc','pharm'])
				break;

			case 'discounts':
				r = app.user?.claims?.admin || app.user?.claims?.supp || org_model.org_conf_itm(app.user.org, 'can_discount')
				break;

			case 'kb_admin':
				r = app.user?.claims?.admin //|| org_model.org_conf_itm(app.user.org, 'can_discount')
				break;
		
			case 'kb_view':
				r = app.user?.claims?.admin || app.user?.claims?.supp || org_model.org_conf_itm(app.user.org, 'can_kb_view_'+p)
				break;

			case 'show_medcat':
			case 'avail_medcat':
				// const cat_flat_list = (await cat_model.get_cat_list())?.cat_flat_list;
				cat_nm = p?.cat_nm || 'pharm'
				const medcat_list = app.app_data.ws_data?.cat_data?.[cat_nm]?.[a=='show_medcat'&&'cat_show_list' || a=='avail_medcat'&&'cat_avail_list'] || [];
				r = ( 
						// app.user?.claims?.root

						// || !app.dvc.org?.conf?.excl_med_cat && !app.user.org?.conf?.excl_med_cat

						// || 
						!app.dvc.org?.conf?.excl_med_cat?.includes(p.k)
							&& !app.user.org?.conf?.excl_med_cat?.includes(p.k)
							&& !app.runtime.org?.conf?.excl_med_cat?.includes(p.k)
							// && (p.cat_nm && p.cat_nm!='pharm' || p.alt_cat && p.alt_cat=='_cosm' || !!cat_flat_list[p.k])
							&& !!medcat_list[p.k]
							// && Object.keys(cat_flat_list).filter( k => k == p.k ).length>0
							// && (await cat_model.get_cat_list()).cat_flat_list.filter( k => k == p.k ).length>0
							// && app.app_data.ws_data.cat_data[cat_model.FRDB_LOC].cat_flat_list.filter( k => k == p.k ).length>0

						|| app.user?.prof?.pts_prescs?.filter?.( pr => pr?.med?.mid==p.k )?.length
						|| consults_for_followup(p.k).length > 0

						|| app.dvc?.org?.conf?.incl_med_cat?.includes(p.k) 
						|| app.user?.org?.conf?.incl_med_cat?.includes(p.k) 
						|| app.runtime?.org?.conf?.incl_med_cat?.includes(p.k) 
						|| app.runtime?.incl_med_cat?.includes(p.k) 

						// || app.dev_env

						// || (document.location.hostname=='localhost' && document.location.port=='9011')
						// || !app.dvc.org && p!="test-cat"
					) 
					&& (!app.dvc.org.conf?.no_medcerts || p!='-LWR6ThuXqNL3jl3hEVv')

				DEBUG && console.log('check_access ', a, p, r);
				break;

			case 'show_medcat_app':
				cat_nm = p?.cat_nm || 'pharm'
				r = 	!!app.app_data.ws_data?.cat_data?.[cat_nm]?.cat_show_list?.[p.k]
				break;

			case 'consult_stats':
				r = (app.user?.claims?.admin || app.user?.claims?.doc)
				break;

			case 'doc_noti':
				r = (app.user?.claims?.root || app.user?.claims?.admin || app.user?.claims?.supp || app.user?.claims?.doc && org_model.org_conf_itm(app.user.org, 'is_GP'))
				break;

			case 'script_appr':
				r = (app.user?.claims?.root || app.user?.claims?.admin || app.user?.claims?.doc && org_model.org_conf_itm(app.user.org, 'is_GP'))
				break;

			case 'onboard_doc':
				r = app.acl.is_admin || app.acl.is_supp;
				break;

			case 'qrgen':
				r = app.acl.is_admin || app.acl.is_supp || app.user?.claims?.mang || app.user?.claims?.mark;
				break;

			case 'statsop':
				r = app.acl.is_admin;
				break;

			case 'appr_algo':
				r = app.acl.is_admin;
				break;

			case 'supp_patho':
				r = app.acl.is_admin || (app.acl.is_supp_patho);
				break;
	
			case '🍞':
				r = app.acl.is_admin || app.acl.is_supp || app.acl.is_doc;
				break;

		}

		return !!r;
	}
	
	static check_any(a) {
		
		if (!Array.isArray(a)) {
			a = [a]
		}
		
		for(const n of a) {
			if (this.check_access(n)) {
				return true
			}
		}
		
		return false
		
	}
	
	static check_all(a) {
		
		if (!Array.isArray(a)) {
			a = [a]
		}
		
		for(const n of a) {
			if (!this.check_access(n)) {
				return false
			}
		}
		
		return true
		
	}
	
	static deny_all(a) {
		return !this.check_any(a)
		
	}

	// ----	--------------------------------------------	--------------------------------------------	

	static limit_access (a, p, nice, goto_after_login) {
		
		if(app.history.location.pathname == '/profile'){ goto_after_login = '/profile' }
		
		const r = this.check_access(a, p);

		if (!r) {

			setTimeout(_=>{
				if (!nice) {
					app.trigger(app.events.SHOW_MESSAGE, 'No Access', 'Please Login', 'negative','user_auth_msg')
				}
				else {
					app.user.user_in &&
						app.trigger(app.events.SHOW_MESSAGE, 'No Access', 'You do not have access to this functionality with this account / on this device.', 'yellow', 'user_auth_msg')
						|| app.trigger(app.events.SHOW_MESSAGE, 'A user account is required to proceed.', 'Please login in to your existing account or create a new account.', 'positive', 'user_auth_msg')
				}

				if (app.dev_env)
					console.log(`NO ACCESS:  `, a, p);

				app.goto_after_login = goto_after_login
							
				if(app.settings.icosm) {
					app.history.push(app.settings.redirect_to_signup && '/get-started' || '/')
					// !app.settings.redirect_to_signup && app.trigger(app.events.REQUEST_LOGIN)
				} else {
					app.history.push(app.settings.redirect_to_signup ? '/login/signup' : '/login')}
			},0)
		}

		return r;
	}

	// ----	--------------------------------------------	--------------------------------------------	
	// ----	--------------------------------------------	--------------------------------------------	

	static async load_script_pts_bysid (sid, enc) {

		return await API_service.load_data(
									'User/scrPts', 
									{sid, enc},
									// r => ca && ca(r)
								) 
	}

	// ----	--------------------------------------------	--------------------------------------------	
	// ----	--------------------------------------------	--------------------------------------------	

	static check_user () {

		firebase_auth.check_user() 

	}

	// ----	--------------------------------------------	--------------------------------------------	
	// ----	--------------------------------------------	--------------------------------------------	

	static async full_logout(force = false) {
		if (force || await app.confirm(`Full logout?`, `This will completely log you out of all your devices.` ) == 'yes') {
			await API_service.load_data(
				'User/fullLogout', 
				{},
			) 
			gtm.log('', 'full_logout');
			user_model.logout()
		}
		

	}

	// 		--------------------------------		--------------------------------		---------
	// 		--------------------------------		--------------------------------		---------

	static async logout() {
		// window.Intercom('shutdown');
		// window.Intercom('boot', { app_id: 'ksq5hplh', hide_default_launcher: !app.site_status?.use_intercom || app.settings.is_cbls || app.settings.is_cmg });
		super.logout();
	}

	// 		--------------------------------		--------------------------------		---------
	// 		--------------------------------		--------------------------------		---------

	static async usr_signup (p) {

		const ret = await API_service.load_data(
									'User/regUsr', 
									p,
									// r => ca && ca(r)
								) 
		const success = ret?.res=='ok'
		gtm.auth(success?'signup':'signup_fail',{type:'usr_signup'})
		return ret
	}

	// 		--------------------------------		--------------------------------		---------

	static async pts_signup (s, p) {

		const ret = await API_service.load_data(
									'User/regPts', 
									{sid:s, ...p},
									// r => ca && ca(r)
								) 
		
		const success = ret?.res=='ok'
		gtm.auth(success?'signup':'signup_fail',{type:'pts_signup',sid:s})
		return ret
	}


	// 		--------------------------------		--------------------------------		---------
	// 		--------------------------------		--------------------------------		---------

	static async load_prof (uid, p) {

		const res = await API_service.load_data(
									'User/loadUserProf', 
									{uid, ...p},
									// r => ca && ca(r)
								) 
		app.runtime.uip = res.uip || null
		// Moving gtm tagging to app_user so as to not consumer new_prof in multiple places
		return res
	}
	
	static async save_prof (d, ca, target) {

		if (!target) {
			target = d.uid && app.user.profs.find(p=>p.uid==d.uid) || !d.uid && d.parent && {} || app.user.prof;
		}
		
		if (!target)
		return ca?.({res:'ok'})
		
		if(d?.dva?.colour == '' && d?.dva?.number == ''){
			d.dva = null
		}
		
		const prof_diff = obj_diff(target, d)
		
		DEBUG && console.log('user_model :: save_prof', app.user.uid, d.uid, prof_diff, Object.keys(prof_diff).length)

		if (!prof_diff.to || !Object.keys(prof_diff.to).length) 
			return ca?.({res:'ok'})

		let params = {...d, prof_diff}

		if (prof_diff.to.first_name || prof_diff.to.last_name)
			params.newname = (prof_diff.to.first_name || target.first_name) + ' ' + (prof_diff.to.last_name || target.last_name)
	
		return await API_service.load_data(
									'User/updateUserProfile', 
									params,
									r => {
										if (r.res == 'ok') {
											if (r.profile?.uid === app.user.uid) {
												app.user.set_profile(r.profile)
												app.trigger(app.events.USER_UPD, 'ProfileUpdated')
											}
										}
										ca && ca(r)	
										
									}
								) 
	}

	static async unlink_prof ({uid, pid}, ca) {

		DEBUG && console.log('user_model :: unlink_prof', uid, pid )

		return await API_service.load_data(
			'User/unlinkProfile', 
			{uid, pid},
			r => ca && ca(r)	
		) 
	}

	static async save_pref(pref,value,save=true) {
		

		// TODO probably not the best way to do this.

		const user = app.user

		DEBUG && console.log('user_model :: save_pref', user.uid)

		const prefs = {...user.prefs, [pref]:value}

		app.user.prefs = prefs

		app.trigger(app.events.USER_UPD, 'PrefsUpdated')

		const extras = { ...app.user.prof.extras } 

		extras.prefs = prefs
	
		return save && user_model.save_prof({uid:user.uid,extras})
	}

	static refresh_prof() {
		setTimeout(async _=>{
			const prof_data = await API_service.load_data(
				'User/loadUserProf', 
				{uid:app.user.uid},
			) 
			if (prof_data) {
				app.user.set_profile(prof_data)
				app.trigger(app.events.USER_UPD, 'ProfileUpdated')
			}
			user_model.refresh_prof()
		},5000)
	}

	// 		--------------------------------		--------------------------------		---------
	// 		--------------------------------		--------------------------------		---------
	// 		--------------------------------		--------------------------------		---------
	
	static save_card(CC_tok, name, ccnum, exp, ca) {
		DEBUG && console.log("save_card()",{CC_tok, name, ccnum, exp});
		const short = ccnum.substring(ccnum.length-4)
		const add_tm = moment().tz("Australia/Melbourne").format('D/M/YY HH:mm:ss')
		const card = {
			CC_tok,
			short,
			name,
			exp,
			add_tm,
		}
		
		const ccs = app.user.prof.ccs || []
		let i = ccs.findIndex(el=>{
			return el.short == short && el.exp == exp
		})
		if (i!=-1) {
			ccs[i] = card
		} else  {
			ccs.unshift(card)
			i = 0
		}
		DEBUG && console.log({ccs});
		user_model.save_prof({ccs:[...ccs]}, result => {
			ca && ca(card, i)
		} )
		
	}
	
	static delete_card(card,ca) {
		const ccs = app.user.prof.ccs && [...app.user.prof.ccs] || []
		let i = ccs.findIndex(el=>{
			return el==card
		})
		DEBUG && console.log({ccs,i});
		if (i!=-1) {
			ccs.splice(i,1)
			user_model.save_prof({ccs}, result => {
				ca && ca()
			} )
			
		}
	}
	
	// 		--------------------------------		--------------------------------		---------
	// 		--------------------------------		--------------------------------		---------
	// 		--------------------------------		--------------------------------		---------

	static role_name (c, top_only=false) {

		if (!c)			return null

		let n = [];

		Object.values(_ROLE_LIST)
				.map( r => c[r.c]&&n.push(r.n) )

		return top_only && n.reverse()[0] || n.reverse().join(', ')

	}

// ----	--------------------------------------------	--------------------------------------------	
// ----	--------------------------------------------	--------------------------------------------	
// ----	--------------------------------------------	--------------------------------------------	
// ----	--------------------------------------------	--------------------------------------------	

	static async set_user_newemail( u, newemail, ca ) {

		return await API_service.load_data(
									'User/setUserNewEmail', 
									{uid: u.prof?.par || u.uid, newemail},
									r => ca && ca(r)
								)
	}

}
